module.exports = __webpack_public_path__ + "static/media/coins.be88ade7.svg";